import { createSelector } from 'reselect';
import selector from './selectors';
import adminReselectors from '../admin/reselectors';
import { statusNieuw } from './authmodule/authcheck';

function wildcardLinkingMatcher(searchTerm: string) {
    if (searchTerm) {
        let term = searchTerm;
        term = term.replace(/[\\]/g, '\\\\');
        term = term.replace(/[\.\?\{\}\[\]\^\$]/g, (x) => `\\${x}`);
        term = term.replace(/\*/g, (x) => `.*`);
        term = term.replace(/\s+/g, ' ');
        term = term.split(' ').qSelect((x) => `(?=.*${x})`).join('');
        const rx = new RegExp(term, 'i');
        return (text: string) => rx.test(text);
    } else {
        return (text: string) => true;
    }
}

const searchTermQuestionMatcherSelector = createSelector(
    selector.searchTermLinkingSelector,
    wildcardLinkingMatcher,
);

export default {   
    questionSelectorSearching: createSelector(
      adminReselectors.questionsItemsSelector, 
      selector.linkitem,
      searchTermQuestionMatcherSelector,
      ( questions, linkitem, wildcardLinkingMatcher) => {
          return questions.qWhere((x) => wildcardLinkingMatcher(x.text) && 
                        x.id !== linkitem.noteId && 
                        linkitem.status===statusNieuw && 
                        !x.parentId);
    },
  ),       
};



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/question/reselectors.tsx